import { render, staticRenderFns } from "./assistantManage.vue?vue&type=template&id=1bfabb57&scoped=true&"
import script from "./assistantManage.vue?vue&type=script&lang=js&"
export * from "./assistantManage.vue?vue&type=script&lang=js&"
import style0 from "./assistantManage.vue?vue&type=style&index=0&id=1bfabb57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfabb57",
  null
  
)

export default component.exports